import React from 'react';
import { Button, notification, Table } from 'antd';
import { popup } from '../../../Components/Columns/popup';

import { TableContainer, TableWrapper } from './list.styled';
import axios from 'axios';
import { onDeletePopup } from '../../../Lib/Api/app';

export default class PopupList extends React.PureComponent {
    onRow = (row, index) => {
        return {
            onClick: () => {
                this.props.history.push({
                    pathname: `/popup/info/${row._id}`,
                    state: {
                        id: row._id,
                    },
                });
            },
        };
    };

    onPopupDelete = async ({ _id }) => {
        console.log('_id: ', _id);

        const confirmed = window.confirm('해당 게시물을 삭제하시겠습니까?');
        if (!confirmed) return null;

        onDeletePopup({ popupId: _id }).then(resolve => {
            if (resolve && resolve.data === 'success') {
                notification.open({
                    message: '게시물을 삭제하였습니다.',
                    description: '게시물을 삭제하였습니다.',
                    type: 'success',
                });
                window.location.reload();
            }
        });
    };

    render() {
        // console.log(this.props.app);
        return (
            <>
                <TableWrapper>
                    <TableContainer>
                        <Table
                            rowKey='id'
                            dataSource={this.props.app.popupList.data}
                            columns={popup({ onDelete: this.onPopupDelete })}
                            onRow={this.onRow}
                            pagination={{
                                pageSize: 10,
                            }}
                        />

                        <Button
                            type='primary'
                            onClick={() => {
                                this.props.history.push('/popup/add');
                            }}
                        >
                            새 게시물 등록
                        </Button>
                    </TableContainer>
                </TableWrapper>
            </>
        );
    }
}
